/* eslint-disable @typescript-eslint/no-misused-promises */
import { Flex, Progress } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { ModalBase } from '../../../../../../components/ModalBase'

interface iModalProps {
  isOpen: boolean
  onRequestClose: () => void
}

export const ModalProgresso: React.FC<iModalProps> = ({ isOpen, onRequestClose }) => {
  const [Timer, setTimer] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(prevTimer => prevTimer + 10)
    }, 200)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    setTimer(0)
  }, [isOpen])

  return (
    <ModalBase
      Titulo='Gerando relatórios, aguarde'
      isOpen={isOpen}
      onClose={onRequestClose}
      Width='35rem'
    >
      <Flex flexDir={'column'} padding={'1rem 1rem'}>
        <Progress value={Timer} min={0} max={100} hasStripe animation={'forwards'} size={'md'} colorScheme='green'/>
      </Flex>
    </ModalBase>
  )
}
